import React from "react";
import { FormProps } from "Utilities/Types";
import Error from "Components/InputsForm/Error";

const Name: React.FC<FormProps> = ({ register, errors, placeholder }) => {
  const minLength = {
    value: 3,
    message: "minLengthName",
  };

  return (
    <>
      <input
        type="text"
        autoComplete="given-name"
        className={
          errors.name ? "input input-focus invalid" : "input input-focus"
        }
        id="name"
        {...register("name", { required: true, minLength, maxLength: 100 })}
        placeholder={placeholder}
      />
      <Error error={errors.name} />
    </>
  );
};

export default Name;
